/**
 * Payment Center Route
 *
 * A parent-friendly page for viewing balances, payment instructions, and history.
 */

import { createFileRoute } from "@tanstack/react-router"

import PaymentCenter from "@/pages/PaymentCenter"

export const Route = createFileRoute("/_layout/payments")({
  component: PaymentCenter,
})
